import { User } from './user';

export class Agreement {
    acceptTime: Date;
    acceptedByUser: User; 
}